<style lang="less">
@import "./assets/css/common.less";
@import "./assets/css/elementReset.less";
</style>
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue